import App from 'next/app';
import Head from 'next/head';
import Router from 'next/router';
import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import withReduxStore from 'src/with-redux-store';
import { appWithTranslation } from '../config/i18n';
import GlobalStyles from 'styles-js/globalStyles';
import cookieControl from 'src/utils/cookieControl';
import { trackPageView, trackPageForPartner } from 'src/utils/analytics';
import anchorLinkOffset from 'src/utils/anchorLinkOffset';
import helpscoutBeacon from 'src/utils/helpscoutBeacon';

import 'styles/base.scss';

// Extract our Sass variables into a JS object
const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../styles/lib/index.scss');

class MyApp extends App {
  componentDidMount() {
    // initialise 3rd party plugins
    cookieControl();
    helpscoutBeacon();

    // Hack to change offset when clicking on an anchor
    anchorLinkOffset();

    // Page view event on page load
    this.logPageView(location.pathname + location.search + location.hash);

    // Listen for route change
    Router.events.on('routeChangeComplete', this.logPageView);
  }

  componentWillUnmount() {
    Router.events.off('routeChangeComplete', this.logPageView);
  }

  logPageView = (url) => {
    trackPageView(url, this.props.pageProps.currentUser);
    trackPageForPartner(this.props.pageProps.community);
  }

  render() {
    const { Component, pageProps, store } = this.props;

    return (
      <Fragment>
        <Head>
          {/* https://github.com/vercel/next.js/blob/master/errors/no-document-viewport-meta.md */}
          <meta content="width=device-width,initial-scale=1" name="viewport" />
        </Head>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <GlobalStyles />
            <Component {...pageProps} />
          </ThemeProvider>
        </Provider>
      </Fragment>
    );
  }
}

export default appWithTranslation(withReduxStore(MyApp));
